import { memo } from 'react'

import CardHeading from '../shared/text/CardHeading'
import ProvidersGrid from './ProvidersGrid'

const StakingProviders = ({ title }) => {
  return (
    <>
      <CardHeading title={title} />
      <ProvidersGrid />
    </>
  )
}

export default memo(StakingProviders)
